<a [href]="directionsUrl" target="_blank">
  <img [src]="url" alt="map">
</a>
